// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"WebinarLoadingBox_wrapper__kQvWL","shimmer":"WebinarLoadingBox_shimmer__0XTHN"};